import { HTTPError } from 'ky';
import get from 'lodash-es/get';
import isNil from 'lodash-es/isNil';

const isHTTPError = (err: unknown): err is HTTPError => !isNil(err) && get(err, 'name') === 'HTTPError';

export default isHTTPError;
